import * as Sentry from '@sentry/react';
import { requireSession } from './store/assertions';

export function enableSentry() {
    const domain = window.location.host;
    let env;
    if (domain.includes('urbanmetrix.com')) {
        env = domain.split('.')[0];
    } else if (domain.includes('localhost')) {
        env = 'local';
    } else {
        env = 'unknown';
    }

    Sentry.init({
        dsn: 'https://ee4261d549b58059a571947f807edf25@o4510737003249664.ingest.de.sentry.io/4510737007116368',
        enabled: import.meta.env.VITE_SENTRY_ENABLED === '1',
        environment: env,
        sendDefaultPii: true,
        integrations: [
            Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
            Sentry.replayIntegration({
                networkDetailAllowUrls: [`${window.location.origin}/api`],
                maskAllText: false,
                blockAllMedia: false,
                maskAllInputs: false,
            }),
            Sentry.feedbackIntegration({
                showBranding: false,
                showName: false,
                showEmail: false,
                autoInject: false,
                colorScheme: 'light',
                triggerLabel: '',
            }),
        ],
        replaysOnErrorSampleRate: 1,
        enableLogs: true,
    });
}

export function identifySentryUser() {
    const userInfo = getUserInfo();
    Sentry.setUser({ id: userInfo.id, username: userInfo.username, email: userInfo.email });
    Sentry.setTag('user.id', userInfo.user_id);
    Sentry.setTag('user.name', userInfo.user_name);
    Sentry.setTag('account.id', userInfo.account_id);
    Sentry.setTag('account.name', userInfo.account_name);
}

export function getUserInfo() {
    const user = requireSession().user;
    const user_id = user.user_id;
    const username = user.name;
    const account_id = user.account_id;
    const account_name = user.accounts?.find((account) => account.id === account_id)?.name;
    const user_email = user.email;

    const id = [user_id, account_id].filter(Boolean).join('-') || undefined;
    const usernameWithAccount = [username, account_name].filter(Boolean).join(' - ') || username;

    return {
        id,
        username: usernameWithAccount,
        email: user_email,
        user_id,
        user_name: username,
        account_id,
        account_name,
    };
}
